// extracted by mini-css-extract-plugin
export default {"productDescription":"x_-z","featuredDescription":"y_-z","description":"z_-z","more":"A_-z","descriptionSku":"B_-z"};